import React, { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Avatar } from "primereact/avatar";
import { FileUpload } from "primereact/fileupload";
import profileService from "./profile-service";
import { InputSwitch } from "primereact/inputswitch";
import { Toolbar } from "primereact/toolbar";
import { useToast } from "../../../components/Toast";
import { useDialog } from "../../../components/Dialog";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Password } from "primereact/password";

const Profile: React.FC = () => {
    const [formData, setFormData] = useState<any>(null);
    const [clientState, setClientState] = useState<any>(null);
    const [image, setImage] = useState<string>("");
    const toast = useRef<Toast>(null);
    const navigate = useNavigate();
    const [displayConfirmation, setDisplayConfirmation] = useState(false);


    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const requiredFields = ["fullName"];

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const { showToast } = useToast();
    const { showExceptionDialog, showConfirmRemarkDialog, showConfirmDialog } = useDialog();

    useEffect(() => {
        const fetchClientState = async () => {
            try {
                profileService.getClientState().then((data) => {
                    setClientState(data);
                    setFormData(data);

                    // profileService.getUserById(data.userId).then((data) => {
                    //     console.log("data", data)
                    //     setFormData(data);

                    //     const profileImage = localStorage.getItem('profileImage');

                    //     if (profileImage !== null) {
                    //         setImage(profileImage);
                    //     }
                    // })
                });



            } catch (error) {
                clientState.error.detail = error;
                showToast(clientState.error);
            }
        };

        fetchClientState();
    }, []);

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value
        });
    };

    const handleUpperCaseInputChange = (e: any) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value.toUpperCase(),
        });
    };

    const handleImageUpload = (event: any) => {
        const file = event.files[0];

        // Check file size limit (5MB)
        const MAX_SIZE = 5 * 1024 * 1024; // 5MB in bytes
        if (file.size > MAX_SIZE) {
            alert("File size exceeds the 5MB limit. Please upload a smaller image.");
            return;
        }

        // Check valid image types
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
        if (!validImageTypes.includes(file.type)) {
            alert("Invalid file type. Please upload a valid image (JPEG, PNG, GIF, BMP, or WebP).");
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e.target?.result) {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    if (!ctx) {
                        alert("Canvas not supported in your browser.");
                        return;
                    }

                    // Crop to square (centered)
                    const minSide = Math.min(img.width, img.height);
                    const sx = (img.width - minSide) / 2; // Start X
                    const sy = (img.height - minSide) / 2; // Start Y

                    // Reduce final image size (Smaller resolution for smaller file size)
                    canvas.width = 500; // Reduced from 800
                    canvas.height = 500; // Reduced from 800

                    // Draw the cropped and resized image
                    ctx.drawImage(img, sx, sy, minSide, minSide, 0, 0, 500, 500);

                    // Convert to JPEG with higher compression (0.4 for smaller size)
                    const compressedImage = canvas.toDataURL('image/jpeg', 0.5);

                    // Validate compressed image size (5MB limit)
                    const compressedImageSize = (compressedImage.length * (3 / 4)) / 1024 / 1024;
                    if (compressedImageSize > 5) {
                        alert("Compressed image size exceeds the 5MB limit. Please upload a smaller image.");
                        return;
                    }

                    // Store image
                    setImage(compressedImage);
                    localStorage.setItem("profileImage", compressedImage);

                    // Update formData data
                    formData.imageUrl = compressedImage;
                    console.log("Cropped & Compressed Image:", compressedImage);

                    profileService.uploadImage(formData).then((resp) => {
                        console.log(resp);
                    });
                };

                img.src = e.target.result as string;
            }
        };

        // Read file as Data URL
        reader.readAsDataURL(file);
    };

    const confirmationDialogFooter = () => {

        function changePassword(): void {
            if (currentPassword.length > 0 && newPassword.length > 0 && confirmPassword.length > 0) {
                if (newPassword === confirmPassword) {
                    profileService.checkPassword(clientState.userId, currentPassword, newPassword).then(() => {
                        showToast(clientState.success);
                        setDisplayConfirmation(false);
                    }).catch((error) => {
                        clientState.error.detail = error.response?.data?.message || 'Failed to update record.';;
                        showToast(clientState.error);
                    });
                } else {
                    clientState.required.detail = "The confirmation password does not match the new password."
                    showToast(clientState.required);
                }

            } else {
                clientState.required.detail = "Please fill all field"
                showToast(clientState.required);
            };
        };

        return (
            <>
                <Button type="button" label="Cancel" icon="pi pi-times" style={{ marginRight: '.5em' }} className="p-button-warning" onClick={() => setDisplayConfirmation(false)} />
                <Button label="Save" icon="pi pi-check" style={{ marginRight: '.5em' }} className="p-button-success" onClick={changePassword} autoFocus />

            </>
        )
    };

    const footerTemplate = () => {
        function submit(): void {
            let newErrors: { [key: string]: string } = {};
            requiredFields.forEach((field) => {
                if (!formData[field]) {
                    newErrors[field] = "This is a required field.";
                    showToast(clientState.required);
                }
            });

            setErrors(newErrors);

            if (Object.keys(newErrors).length === 0) {

                showConfirmDialog("Confirmation", "Are you sure you want to save this?", () => {

                    const currentDate = new Date().toLocaleString("en-US", { timeZone: clientState.timeZone });

                    formData.modifiedDate = new Date(currentDate);
                    formData.modifiedBy = clientState.userId;

                    profileService.update(formData).then(() => {
                        showToast(clientState.success);
                    }).catch((error) => {
                        clientState.error.detail = error.response?.data?.message || 'Failed to update record.';
                        showToast(clientState.error);
                    });
                });
            }
        }

        const changePassword = (): void => {
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
            setDisplayConfirmation(true);
        };

        return (
            <>
                <Button label="Change Password" icon="pi pi-unlock" style={{ marginRight: '.5em' }} className="p-button-warning" onClick={changePassword} />
                <Button label="Save" icon="pi pi-check" style={{ marginRight: '.5em' }} className="p-button-success" onClick={submit} />

                <Dialog
                    header="Change Password"
                    visible={displayConfirmation}
                    onHide={() => setDisplayConfirmation(false)}
                    style={{ width: '350px' }}
                    modal
                >
                    <div className="p-fluid">
                        <div className="p-field mb-3">
                            <label htmlFor="currentPassword">Current Password</label>
                            <Password id="currentPassword" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} feedback={false} toggleMask />
                        </div>
                        <div className="p-field mb-3">
                            <label htmlFor="newPassword">New Password</label>
                            <Password id="newPassword" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} toggleMask />
                        </div>
                        <div className="p-field mb-3">
                            <label htmlFor="confirmPassword">Confirm New Password</label>
                            <Password id="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} feedback={false} toggleMask />
                        </div>
                    </div>
                    <div>
                        <br />
                    </div>
                    <Toolbar end={confirmationDialogFooter}></Toolbar>
                </Dialog>

            </>
        );
    };

    return (
        <div className="grid">
            <div className='col-12'>
                <Card title="User Profile"></Card>
                <br></br>
                <Card>
                    <div className="p-fluid form-grid grid">
                        
                        <div className="field col-12 md:col-6">
                            <label>Full Name</label>
                            <InputText id="name" name="name" value={formData?.userData.name} readOnly/>
                            {errors.name && <small className="p-error">{errors.name}</small>}
                        </div>
                        <div className="field col-12 md:col-6">
                            <label>Email</label>
                            <InputText id="email" name="email" value={formData?.userData.email} readOnly />
                        </div>
                        <div className="field col-12 md:col-6">
                            <label>Job Tittle</label>
                            <InputText name="jobTitle" value={formData?.userData.jobTitle} readOnly />
                        </div>
                        <div className="field col-12 md:col-6">
                            <label>Phone No.</label>
                            <InputText id="mobilePhone" name="mobilePhone" value={formData?.userData.mobilePhone}/>
                        </div>
                    </div>
                    <div>
                        <br />
                    </div>
                    {/* <Toolbar end={footerTemplate}></Toolbar> */}
                </Card>


            </div >
        </div >
    );
};

export default Profile;
